/**
 * 浏览器调用语音合成接口
 * @param {Object} param 百度语音合成接口参数
 * 请参考 https://ai.baidu.com/docs#/TTS-API/41ac79a6
 * @param {Object} options 跨域调用api参数
 *           timeout {number} 超时时间 默认不设置为60秒
 *           volume {number} audio控件音量，范围 0-1
 *           hidden {boolean} 是否隐藏audio控件
 *           autoDestory {boolean} 播放音频完毕后是否自动删除控件
 *           onInit {Function} 创建完audio控件后调用
 *           onSuccess {Function} 远程语音合成完成，并且返回音频文件后调用
 *           onError {Function}  远程语音合成完成，并且返回错误字符串后调用
 *           onTimeout {Function} 超时后调用，默认超时时间为60秒
 */
// import mp3Url from './did.mp3'
export function btts(param, options) {
  var url = 'https://tsn.baidu.com/text2audio';
  //var url = 'https://tsn.baidu.com/text2audio';
  var opt = options || {};
  var p = param || {};
  console.log(p);
  // let isEnd = false;

  // 如果浏览器支持，可以设置autoplay，但是不能兼容所有浏览器
  var audio = document.createElement('video');
  if (opt.autoplay) {
    audio.setAttribute('autoplay', 'autoplay');
  }
  // 隐藏控制栏
  if (!opt.hidden) {
    audio.setAttribute('controls', 'controls');
  } else {
    audio.style.display = 'none';
  }

  // 设置音量
  if (typeof opt.volume !== 'undefined') {
    audio.volume = opt.volume;
  }

  // 调用onInit回调
  isFunction(opt.onInit) && opt.onInit(audio);

  // 默认超时时间60秒
  var DEFAULT_TIMEOUT = 60000;
  var timeout = opt.timeout || DEFAULT_TIMEOUT;

  // 创建form参数
  var data = {};
  for (let p in param) {
    data[p] = param[p]
  }

  // 赋值预定义参数

  data.cuid = data.cuid || data.tok;
  data.ctp = 1;
  data.lan = data.lan || 'zh';
  data.aue = data.aue || 3;

  // 序列化参数列表
  var fd = [];
  for (var k in data) {
    fd.push(k + '=' + encodeURIComponent(data[k]));
  }

  // 用来处理blob数据
  // var frd = new FileReader();
  // 用timeout可以更兼容的处理兼容超时
  var timer = setTimeout(function () {
    isFunction(opt.onTimeout) && opt.onTimeout();
  }, timeout);
  document.body.appendChild(audio);
  // audio.setAttribute("display", "none");
  audio.removeAttribute("controls");
  // audio.setAttribute('src', url + '?' + fd.join('&'));
  audio.setAttribute('autoplay', 'autoplay');
  let sour = '<source src="' + url + '?' + fd.join('&') + '" type="audio/mp3"/>';
  // let sour = '<source src="'+ mp3Url +'" type="audio/mp3"/>';
  audio.innerHTML = sour;
  audio.load();
  audio.pause();
  // audio.play()
  let audioPlay = audio.play();
  try {
    audioPlay.then(() => {//判断当前浏览器能否自动播报语音
      audio.play()
      // console.log('可以自动播放')
    }).catch((error) => {//不能自动播放事件
      console.log(error);
      isFunction(opt.onContAutoPlay) && opt.onContAutoPlay(audio)
    });
  } catch (e) {
    if (audioPlay) {
      audio.play()
    } else {
      isFunction(opt.onContAutoPlay) && opt.onContAutoPlay(audio)
    }
  }
  
  audio.oncanplay = function () {
    clearTimeout(timer);
    isFunction(opt.onCanplay) && opt.onCanplay(audio)
  };
  audio.onended = function () {
    // if(isEnd) {
    //   console.log(111);
    clearTimeout(timer);
    try {
      document.body.removeChild(audio);
    } catch (e) {
      audio.innerHTML = "";
      let parentNode = audio.parentNode
      if (parentNode) {
        parentNode.removeChild(audio)
      }
    }
    isFunction(opt.onSuccess) && opt.onSuccess(audio);
    // }else {
    //   console.log(123);
    //   isEnd = true;
    //   let sour1 = '<source src="'+ url + '?' + fd.join('&')+'" type="audio/mp3"/>';
    //   audio.innerHTML = sour1;
    //   audio.play();
    // }
  };
  audio.addEventListener("error", function () {
    clearTimeout(timer);
    try {
      document.body.removeChild(audio);
    } catch (e) {
      audio.innerHTML = "";
      let parentNode = audio.parentNode
      if (parentNode) {
        parentNode.removeChild(audio)
      }
    }
    isFunction(opt.onError) && opt.onError("链接加载失败")
  });
}

// 判断是否是函数
function isFunction(obj) {
  if (Object.prototype.toString.call(obj) === '[object Function]') {
    return true;
  }
  return false;
}

export function createAudio(option) {
  var eee = sessionStorage.getItem("adnum");
  let opt = option || {};
  if (opt['text']) {
    btts({
      tex: option['text'] || "",
      tok: option['token'] || '24.1758a5df4e5d0289526b59d6933a756c.2592000.1574930884.282335-17618448',
      spd: 6,//语速
      pit: 5,//音调
      vol: 15,//音量
      per: eee ? eee : 0,//度小宇=1，度小美=0，度逍遥（基础）=3，度丫丫=4
      // aue: 6,//3为mp3格式(默认)； 4为pcm-16k；5为pcm-8k；6为wav（内容同pcm-16k）; 注意aue=4或者6是语音识别要求的格式，但是音频内容不是语音识别要求的自然人发音，所以识别效果会受影响。
    }, {
      volume: 0.3,
      autoDestory: true,
      // timeout: 10000,
      hidden: false,
      onInit: function (htmlAudioElement) {
        isFunction(opt.onInit) && opt.onInit(htmlAudioElement);
      },
      onCanplay: function (htmlAudioElement) {
        isFunction(opt.onCanplay) && opt.onCanplay(htmlAudioElement)
      },
      onContAutoPlay: function (htmlAudioElement) {
        isFunction(opt.onContAutoPlay) && opt.onContAutoPlay(htmlAudioElement)//不能自动播放点击播放事件
      },
      onSuccess: function (htmlAudioElement) {
        isFunction(opt.onSuccess) && opt.onSuccess(htmlAudioElement)
      },
      onError: function (text) {
        console.log("播放失败")
        isFunction(opt.onError) && opt.onError(text)
      },
      onTimeout: function () {
        isFunction(opt.onTimeout) && opt.onTimeout();
        // alert('timeout')
        console.log("请求超时")
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/plugins/voice_tts.js